<div class="row mt-2">
    <div class="col-md-12">
        <div class="card card-accent-success">
            <div class="card-header-buscador">
                <i class="fa fa-align-justify"></i> Listado de {{ title.plural }} de la U.I.
            </div>
    
            <div class="card-body-grid" *ngIf="result">
    
                <p-table #tableSearch autoLayout="true" [value]="result" [lazy]="true"
                    [lazyLoadOnInit]="false" [rowHover]="true" selectionMode="none"
                    dataKey="Id" rowExpandMode="single"
                    [paginator]="false" [columns]="cols" sortOrder="0" 
                    [totalRecords]="result?.length" [loading]="loading"
                    [ngClass]="displayGridHidden(result)"
                    styleClass="table table-responsive-sm table-striped table-sm">
    
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th nowrap scope="col" *ngFor="let col of columns" [ngClass]="{ 'th-xs': col.reduce }" [ngStyle]="{'display': col.display}"
                                [pSortableColumn]="col.field">
                                {{col.header}}
                                <p-sortIcon *ngIf="col.field!=='Link' && col.field!=='Image' && col.field!=='ExpandLink'" [field]="col.field"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
    
                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                        <tr>
                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [ngClass]="{ 'td-xs': col.reduce }">
                                <ng-container *ngIf="col.field==='ExpandLink'">
                                    <div class="btn-group">
                                        <span>
                                            <a href="#" class="btn button-row-expand align-chevron" [pRowToggler]="rowData" 
                                                [title]="expanded ? 'Colapsar detalle de la U.I.' : 'Expandir detalle de la U.I'"
                                                [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                                            </a>
                                        </span>
                                    </div>
                                </ng-container>
                                <span *ngIf="col.field==='Image'">
                                    <img class="estado-icono" src="{{ rowData.IdEstadoUi | IconoEstadoUnidadInspeccion }}" container="body" ngbTooltip="{{ rowData.EstadoUi || SIN_ASIGNAR }}" />
                                </span>
                                <ng-container *ngIf="col.field === 'Link'" class="btn-group">
                                    <ng-container *ngIf="hasViewAccess(rowData)">
                                        <button (click)="onView(rowData)" type="button" class="btn btn-sm btn-info" title="Consultar {{ title.singular }}">
                                            <span class="fa fa-eye"></span>
                                        </button>
                                    </ng-container>
                                    <ng-container *ngIf="hasDeleteAccess(rowData) && !readonly && tableSearch?.totalRecords > 1">
                                        <button (click)="onDelete(rowData)" type="button" class="btn btn-sm btn-danger" title="Desvincular {{ title.singular }} de U.I.">
                                            <span class="fa fa-remove"></span>
                                        </button>
                                    </ng-container>
                                </ng-container>
                                <span *ngIf="col.field!=='Image' && col.field!=='Link' && col.field!=='ExpandLink'">
                                    {{ rowData[col.field] }}
                                </span>
                            </td>
                        </tr>
                    </ng-template>

                    <!-- Template equivalente al del componente buscador-unidad-inspeccion-list -->
                    <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns">
                        <tr>
                            <td [attr.colspan]="9">
                                <table class="table-subtable" *ngIf="rowData.IdTipoSolicitudCam === ID_TIPO_PARCELA || rowData.IdTipoSolicitudCam === ID_TIPO_INVERNADERO">
                                    <thead class="table-subtable-thead">
                                        <tr>
                                            <th class="th-md">&nbsp;</th>
                                            <th>F. Presentación</th>
                                            <th>Código Solicitud</th>
                                            <th>Operador</th>
                                            <th>Titular</th>
                                            <th>NIF</th>
                                            <th>Provincia</th>
                                            <th>Municipio</th>
                                            <th>Código SigPac</th>
                                            <th>Superficie Recinto (ha)</th>
                                            <th>Id. Cultivo</th>
                                            <th>Variedad</th>
                                            <th>Nombre Cientifico</th>
                                            <th>Superficie Variedad (ha)</th>
                                            <th>Desautorizado</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>{{ rowData?.Cultivo?.SolicitudCam?.FechaPresentacion | date:'dd/MM/yyyy HH:mm' }}</td>
                                            <td>{{ rowData?.Cultivo?.SolicitudCam?.CodigoSolicitud }}</td>
                                            <td>{{ rowData?.Cultivo?.SolicitudCam?.OperadorRazonSocial }}</td>
                                            <td>{{ rowData?.Cultivo?.Recinto?.Titular }}</td>
                                            <td>{{ rowData?.Cultivo?.Recinto?.Nif }}</td>
                                            <td>{{ rowData?.Cultivo?.Recinto?.Provincia }}</td>
                                            <td>{{ rowData?.Cultivo?.Recinto?.Municipio }}</td>
                                            <td>{{ rowData?.Cultivo?.Recinto?.CodigoSigPac }}</td>
                                            <td>{{ rowData?.Cultivo?.Recinto?.SuperficieTotal | number:'1.2-5':'es-ES' }}</td>
                                            <td>{{ rowData?.Cultivo?.Identificador }}</td>
                                            <td>{{ rowData?.Cultivo?.Variedad }}</td>
                                            <td>{{ rowData?.Cultivo?.NombreCientifico }}</td>
                                            <td>{{ rowData?.Cultivo?.SuperficieVariedad | number:'1.2-5':'es-ES' }}</td>
                                            <td>{{ rowData?.Cultivo?.Desautorizado | siNo }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table class="table-subtable" *ngIf="rowData.IdTipoSolicitudCam === ID_TIPO_EMP_DESHIDRATADORA">
                                    <thead class="table-subtable-thead">
                                        <tr>
                                            <th class="th-md">&nbsp;</th>
                                            <th>F. Presentación</th>
                                            <th>Código Solicitud</th>
                                            <th>Operador</th>
                                            <th>Número Registro</th>
                                            <th>Nombre Industria</th>
                                            <th>Provincia</th>
                                            <th>Municipio</th>
                                            <th>Desautorizada</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>{{ rowData?.EmpresaDeshidratadora?.SolicitudCam?.FechaPresentacion | date:'dd/MM/yyyy HH:mm' }}</td>
                                            <td>{{ rowData?.EmpresaDeshidratadora?.SolicitudCam?.CodigoSolicitud }}</td>
                                            <td>{{ rowData?.EmpresaDeshidratadora?.SolicitudCam?.OperadorRazonSocial }}</td>
                                            <td>{{ rowData?.EmpresaDeshidratadora?.NumeroRegistro }}</td>
                                            <td>{{ rowData?.EmpresaDeshidratadora?.NombreIndustria }}</td>
                                            <td>{{ rowData?.EmpresaDeshidratadora?.Provincia }}</td>
                                            <td>{{ rowData?.EmpresaDeshidratadora?.Municipio }}</td>
                                            <td>{{ rowData?.EmpresaDeshidratadora?.Desautorizada | siNo }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table class="table-subtable" *ngIf="rowData.IdTipoSolicitudCam === ID_TIPO_ALMACEN">
                                    <thead class="table-subtable-thead">
                                        <tr>
                                            <th class="th-md">&nbsp;</th>
                                            <th>F. Presentación</th>
                                            <th>Código Solicitud</th>
                                            <th>Operador</th>
                                            <th>Razón Social</th>
                                            <th>Registro Sanitario</th>
                                            <th>Provincia</th>
                                            <th>Municipio</th>
                                            <th>Desautorizado</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>{{ rowData?.Almacen?.SolicitudCam?.FechaPresentacion | date:'dd/MM/yyyy HH:mm' }}</td>
                                            <td>{{ rowData?.Almacen?.SolicitudCam?.CodigoSolicitud }}</td>
                                            <td>{{ rowData?.Almacen?.SolicitudCam?.OperadorRazonSocial }}</td>
                                            <td>{{ rowData?.Almacen?.RazonSocial }}</td>
                                            <td>{{ rowData?.Almacen?.RegistroSanitario }}</td>
                                            <td>{{ rowData?.Almacen?.Provincia }}</td>
                                            <td>{{ rowData?.Almacen?.Municipio }}</td>
                                            <td>{{ rowData?.Almacen?.Desautorizado | siNo }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr> 
                    </ng-template>

                </p-table>
                    
                <div class="empty-grid" *ngIf="tableSearch?.totalRecords === 0">No se ha encontrado ningún registro</div>
                <div *ngIf="tableSearch?.totalRecords === 1" class="p-2">Se ha encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registro</div>
                <div *ngIf="tableSearch?.totalRecords > 1" class="p-2">Se han encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registros</div>

                <div class="nota-info m-1" *ngIf="tableSearch?.totalRecords === 1 && !readonly">
                    <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Para poder borrar un(a) {{ title.singular }} de la U.I., tendrá que haber un mínimo de dos</label>
                </div>
            </div>
    
        </div>
    </div>
</div>

